import { action_workflow_steps } from './corrective_actions_data';
import { action_drawer_catalog_a } from './corrective_actions_drawer_data_a';
import { action_drawer_catalog_b } from './corrective_actions_drawer_data_b';

export const action_drawer_catalog = { ...action_drawer_catalog_a, ...action_drawer_catalog_b };

export const corrective_drawer_computed = {
  active_action_drawer() {
    return this.all_action_rows.find((row) => row.ref === this.active_action_drawer_ref) || null;
  },
  active_action_drawer_details() {
    return action_drawer_catalog[this.active_action_drawer_ref] || null;
  },
  active_action_workflow() {
    const current_label = this.active_action_drawer?.status?.label;
    const current_index = action_workflow_steps.indexOf(current_label);
    return action_workflow_steps.map((step, index) => ({ label: step, state: current_index === -1 ? 'upcoming' : index < current_index ? 'done' : index === current_index ? 'current' : 'upcoming' }));
  }
};
